module.exports = __webpack_public_path__ + "static/media/siri03.bd2d1dbe.jpg";